import React from "react";
import Card from "components/card";
import Button from "components/button";

import {
    FileText,
    Download,
    ExternalLink,
    Paperclip,
} from "lucide-react";

const AttachmentCard = ({
    attachment,
    onDownload,
    onView,
}) => {
    return (
        <Card className="space-y-1.5">
            <div className="flex items-center justify-between p-2 sm:p-2.5 rounded-xl border-2 border-slate-200 dark:border-zinc-700 hover:border-blue-300 dark:hover:border-blue-700 hover:bg-blue-50/50 dark:hover:bg-blue-950/30 transition-all group">
                
                <div className="flex items-center gap-2 flex-1 min-w-0">
                    <div className="p-1.5 rounded-lg bg-blue-100 dark:bg-blue-900/50 text-blue-600 dark:text-blue-400 flex-shrink-0">
                        <Paperclip className="w-3.5 h-3.5" />
                    </div>

                    <div className="min-w-0">
                        <p className="text-[11px] sm:text-[12px] font-medium truncate dark:text-zinc-100">
                            {attachment?.name}
                        </p>
                    </div>
                </div>

                <div className="flex gap-1 flex-shrink-0">
                    <Button
                        onClick={() => onDownload?.(attachment)}
                        className="inline-flex items-center justify-center whitespace-nowrap font-medium transition-all rounded-md gap-1.5 h-7 text-[10px] sm:text-[11px] px-2 hover:bg-slate-200 hover:text-slate-900 hover:shadow-none"
                    >
                        <Download className="w-3 h-3 sm:mr-1" />

                        <span className="hidden sm:inline">
                            Download
                        </span>
                    </Button>

                    <Button
                        onClick={() => onView?.(attachment)}
                        className="hidden sm:inline-flex items-center justify-center whitespace-nowrap font-medium transition-all rounded-md gap-1.5 h-7 text-[10px] sm:text-[11px] px-2 hover:bg-slate-200 hover:text-slate-900 hover:shadow-none"
                    >
                        <ExternalLink className="w-3 h-3 sm:mr-1" />
                        View
                    </Button>
                </div>
            </div>
        </Card>
    );
};

export default AttachmentCard;